import { App } from "@capacitor/app";
import { PluginListenerHandle } from "@capacitor/core";
import { onBeforeUnmount, onMounted } from "vue";

const RELOAD_COUNT_KEY = "versionCheckReloadCount";
const MAX_RELOADS = 2;

export default function () {
  const buildVersion = import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA;
  let appStateListener: PluginListenerHandle | undefined;

  onMounted(async () => {
    checkVersion();

    appStateListener = await App.addListener("appStateChange", (state) => {
      if (state.isActive) checkVersion();
    });
  });

  onBeforeUnmount(() => {
    appStateListener?.remove();
  });

  async function fetchServerVersion () {
    try {
      const response = await fetch(`/api/version?t=${Date.now()}`, {
        cache: "no-store",
      });

      if (!response.ok) return null;

      const {
        version,
      } = await response.json();

      return version as string | null;
    } catch {
      return null;
    }
  }

  async function checkVersion () {
    if (import.meta.env.MODE !== "production") return;

    const serverVersion = await fetchServerVersion();
    if (!serverVersion || serverVersion === buildVersion) return;

    const currentVersionParam = new URLSearchParams(window.location.search).get("v");
    if (currentVersionParam === serverVersion) {
      sessionStorage.removeItem(RELOAD_COUNT_KEY);
      return;
    }

    const reloadCount = Number(sessionStorage.getItem(RELOAD_COUNT_KEY) ?? "0");
    if (reloadCount >= MAX_RELOADS) return;

    sessionStorage.setItem(RELOAD_COUNT_KEY, String(reloadCount + 1));

    reloadWithServerVersion(serverVersion);
  }

  function reloadWithServerVersion (serverVersion: string) {
    const url = new URL(window.location.href);
    url.searchParams.set("v", serverVersion);
    window.location.replace(url.toString());
  }
}
